import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";

const IconGoogle = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#fbc02d",
    d: "M44 20H24v8h11a12 12 0 11-3-13l6-6A20 20 0 004 24a20 20 0 1040-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M6 15l7 5a12 12 0 0119-5l6-6a20 20 0 00-32 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M24 44c5 0 10-2 13-5l-6-5a12 12 0 01-18-6l-7 5c4 7 10 11 18 11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    d: "M44 20H24v8h11c0 2-2 4-4 6l6 5s7-5 7-15v-4z"
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(IconGoogle, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;